import { useEffect, useState } from 'react';

export const RefreshIcon = () => {
  const [color, setColor] = useState('');
  const DOMstyle = document.documentElement.style;

  useEffect(() => {
    const color = DOMstyle.getPropertyValue("--custom-primary-text-color");
    setColor(color);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <svg width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M2.57787 5.25C3.96782 2.70934 6.56573 1 9.54121 1C12.9149 1 15.8031 3.19743 16.9957 6.3125M5.01939 6.3125H1V2.0625M16.4221 13.75C15.0322 16.2907 12.4343 18 9.45879 18C6.08513 18 3.19686 15.8026 2.00433 12.6875M13.9806 12.6875H18V16.9375" stroke={color || "#151A35"} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  );
};
